import { createSelector } from "reselect";

export const printersSelector = createSelector((state) => {
  const { printers, companies } = state;
  return printers.printers?.map((printer) => {
    return {
      ...printer,
      station: companies.stations[printer.idStation]?.label
    }
  })
  
  },
  (printers) => printers || []
)